import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl.js"
import "medium-editor/dist/css/medium-editor.min.css"
import "medium-editor/dist/css/themes/beagle.min.css"
import Pjax from "pjax"

export class PageDocs implements ClientPage {
  public pjax: Pjax

  getPageId = (): string => "docs"

  execute = (pjax: Pjax): void => {
    this.pjax = pjax

    const versionSelect = document.getElementById("docsVersionSelect") as HTMLSelectElement
    versionSelect.onchange = (): void => {
      this.pjax.loadUrl(`/docs/${versionSelect.value}`)
    }
  }

  onPageClose = (): void => {}
}
